export default import.meta.ROLLDOWN_FILE_URL_8dm3C3jsXN$7yE9lr2nMCQ